export function FullPageLoading({ label = 'Carregando…' }: { label?: string }) {
  return (
    <div className="page-loading" role="status">
      <div className="spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
